import { createContext, useContext, useEffect, useState } from "react";
import api from "@/lib/api";

const LaunchContext = createContext({ config: null, loading: true, refresh: () => {} });

export function LaunchProvider({ children }) {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);

  const load = async () => {
    try {
      const { data } = await api.get("/launch/config");
      setConfig(data);
    } catch {
      // Iter 125: the site is permanently in ``public_launch``.  When the
      // config endpoint is unreachable (network hiccup, cold-start), default
      // to the launched state so first paint never flashes the retired
      // coming-soon interstitial.  If admin later flips the DB back to
      // ``coming_soon``, a successful refresh will overwrite this optimistic
      // default and the guard will re-engage.
      setConfig({
        launch_mode: "public_launch",
        public_login_enabled: true,
        public_registration_enabled: true,
        private_preview_login_enabled: false,
        early_access_form_enabled: false,
        collection_previews_enabled: true,
        trust_preview_enabled: true,
        concierge_preview_enabled: true,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  return (
    <LaunchContext.Provider value={{ config, loading, refresh: load }}>
      {children}
    </LaunchContext.Provider>
  );
}

export function useLaunch() {
  return useContext(LaunchContext);
}

/** True when the marketplace/private surfaces are open to a given user. */
export function marketplaceOpen(config, user) {
  if (!config) return false;
  const mode = config.launch_mode;
  const INTERNAL = ["concierge_staff","marketplace_admin","verification_admin","certification_admin",
    "valuation_admin","transaction_admin","auction_admin","support_admin","finance_admin",
    "content_admin","executive_admin","super_admin","admin"];
  if (mode === "public_launch") return true;
  if (user && INTERNAL.includes(user.role)) return true;
  if (mode === "private_preview" && user && user.preview_access_status === "approved") return true;
  return false;
}
